import { translate } from '../../../../Internationalization';
import InfoPopover from '../../../../../shared/Popover/Popover';
import genericDates from 'config/local/generic-dates';
import React from 'react';

export default class GenericAvmLeadScore extends React.Component {
	/**
	 * @param {string} contact
	 * @param {number} index
	 * @returns {JSX.Element}
	 */
	static #renderContact(contact, index) {
		// const contactType = this.#renderContactType(contact, index)
		return (
			<li className="list-item" key={index}>
				<header className="justified-row items-center">
					<div className="flex items-center">
						<h4 className="hl-ms mr-2">
							{translate(
								`agent.pages.dashboard.contacts.generic.name.${index}`
							)}
						</h4>
					</div>
					<section className="flex items-center">{contact}</section>
				</header>
			</li>
		);
	}
	/* eslint-disable class-methods-use-this -- this render function does not currently use 'this'*/

	render() {
		const genericContactList = genericDates.map(
			/**
			 * @param {{daterequested:string }} contact
			 * @param {number} index
			 * @returns {JSX.Element}
			 */
			(contact, index) =>
				GenericAvmLeadScore.#renderContact(
					contact.daterequested,
					index + 1
				)
		);

		return (
			<section className="mt-10">
				<section className="card card-border-light">
					<header className="card-header bg-theme-light text-theme-fg-light">
						<div className="h-ms-1">
							{translate(
								'agent.pages.contacts.view.upgrade_table.avm_lead_title'
							)}
							<InfoPopover
								content={translate(
									'agent.pages.dashboard.avmLead_board.description'
								)}
							/>
						</div>
					</header>
					<ul className="list-group card-list divided px-3 relative">
						{genericContactList}
						<div className="overlay-faded" />
					</ul>
				</section>
			</section>
		);
	}

	/* eslint-enable */
}
